import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

export default function CustomizedMenus() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <select id="cars" style={{ border: "0px", outline: "none", backgroundColor: "#065DFF", color: "#fff" }}>
                <option value="volvo">  SAR Agrochemicals Fertilizers Pvt. Ltd.</option>
                <option value="saab">  ATFEM KHETIGAADI Pvt. Ltd.</option>
                <option value="opel">Agriola International LLP</option>
                <option value="audi">Agripal Global LLP</option>
            </select>
            {/* <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
                style={{ fontFamily: "sans-serif", fontSize: "12px", background: "none" }}
            >
                SAR Agrochemicals Fertilizers Pvt. Ltd.
            </Button>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose} disableRipple style={{ fontFamily: "sans-serif", fontSize: "15px" }} >
                    <EditIcon />
                    ATFEM KHETIGAADI Pvt. Ltd.
                </MenuItem>
                <MenuItem onClick={handleClose} disableRipple style={{ fontFamily: "sans-serif", fontSize: "15px" }}>
                    <FileCopyIcon />
                    Agriola International LLP
                </MenuItem>
                <MenuItem onClick={handleClose} disableRipple style={{ fontFamily: "sans-serif", fontSize: "15px" }}>
                    <ArchiveIcon />
                    SAR Agromart Retail Pvt. Ltd.
                </MenuItem>
                <MenuItem onClick={handleClose} disableRipple style={{ fontFamily: "sans-serif", fontSize: "15px" }}>
                    <MoreHorizIcon />
                    Agripal Global LLP
                </MenuItem>
            </StyledMenu> */}


        </div>
    );
}


